import { SYSBaseElement, html } from "../../../../../../../_ovlclient/src"
import { T } from "../../../../../../../_ovlclient/src/textapi"
import type { KPIContainerProps } from "../../../features/kpi/kpicontainer"
import { FormHandlingType } from "../../../../../../../_ovlclient/src/library/dialog/sysdialogbase"
import { BPFilterFields } from "../../../components/bpfilter/formdef"
import { FormGet } from "../../../../../../../_ovlclient/src/library/forms/formapi"
import { FeatureInfo } from "../../../../../../../_ovlclient/src/global/globalapi"
import "./custom.css"

export class CompKPIAll extends SYSBaseElement {
  
  async init() {
      // Ensure the filter is initialized with the current user's card code
      BPFilterFields.CardCode.value = this.state.ovl.user.cardCode
      await super.init()
  }

  async getUI() {
    const filterCardCode = FormGet("QUTBPFilter")?.formState?.fields?.CardCode?.value

    return html`
      <div class="fd-layout-panel ovl-screen-KPIAll">
        <div class="kpi-print-header">
           ${filterCardCode ? html`<h2>${filterCardCode}</h2>` : ""}
        </div>
        ${FeatureInfo("QUTOfferingToolAdmin") ? html`
          <div class="fd-layout-panel__header">
            <div class="fd-layout-panel__actions">
              <h4>
                ${T("QUTOfferingOfferingAdminSelectCustomer")}
              </h4>
              <comp-genbpfilter
                .formHandling=${<FormHandlingType>{
                  formType: "QUTBPFilter",
                  autoInit: true,
                  creation: {
                    autoInitFormFields: BPFilterFields,
                  },
                }}
              ></comp-genbpfilter>
            </div>
          </div>
        ` : null}
        <div class="fd-layout-panel__body">
          <comp-kpicontainer .props=${{ type: "All", filterCardCode: filterCardCode } as KPIContainerProps}></comp-kpicontainer>
        </div>
      </div>
    `
  }
}
